(()=>{if(window.AWP1CollectionFilters?.version)return;
const VERSION='1.8.0';
const TECHNICAL_PREFIXES=['filter.p.m.aw_filters.','filter.p.m.compatibilite.'];
const track=(name,data={})=>{try{window.AWAnalytics?.track?.(name,data)}catch(_){}};
const bindTracking=()=>{try{window.AWP1LiteTracking?.bind?.(document)}catch(_){}};
const technicalParamsInDom=()=>new Set(
  [...document.querySelectorAll('[data-aw-technical-param]')]
    .map(node=>node.dataset.awTechnicalParam)
    .filter(Boolean)
);
const isTechnicalParam=(param)=>TECHNICAL_PREFIXES.some(prefix=>param.startsWith(prefix));
const sanitizeTechnicalParams=()=>{
  const allowed=technicalParamsInDom();
  const url=new URL(location.href);
  let changed=false;
  [...new Set([...url.searchParams.keys()])].forEach(param=>{
    if(isTechnicalParam(param)&&!allowed.has(param)){
      url.searchParams.delete(param);
      changed=true;
    }
  });
  if(!changed)return false;
  url.searchParams.delete('page');
  location.replace(url.href);
  return true;
};

const initDrawer=(drawer)=>{
  if(!drawer||drawer.dataset.awFilterReady==='true')return;
  const groupCount=Number(drawer.dataset.groupCount||0);
  const collectionCount=Number(drawer.dataset.collectionCount||0);
  if(groupCount<1||collectionCount<6)return;

  const panel=drawer.querySelector('[data-aw-filter-panel]');
  const form=drawer.querySelector('[data-aw-filter-form]');
  const closeButtons=[...drawer.querySelectorAll('[data-aw-filter-close]')];
  const clearButton=drawer.querySelector('[data-aw-filter-clear]');
  const applyButton=drawer.querySelector('.aw-filter-drawer__apply');
  const toolbar=document.querySelector('.aw-p1-collection__toolbar')||document.querySelector('.collection-grid-premium .collection-toolbar');
  if(!panel||!form||!toolbar)return;

  const allowedParams=()=>[...new Set(
    [...drawer.querySelectorAll('[data-aw-technical-param]')]
      .map(node=>node.dataset.awTechnicalParam)
      .filter(Boolean)
  )];
  const checkedInputs=()=>[...form.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)')];
  const focusableNodes=()=>[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),details > summary,[tabindex]:not([tabindex="-1"])')]
    .filter(node=>node.getClientRects().length>0&&!node.closest('[hidden]'));

  let trigger=toolbar.querySelector('.aw-collection-filter-trigger');
  if(!trigger){
    trigger=document.createElement('button');
    trigger.type='button';
    trigger.className='aw-collection-filter-trigger';
    trigger.setAttribute('aria-controls','AWCollectionFilters');
    trigger.setAttribute('aria-expanded','false');
    trigger.dataset.awP1Track='collection_filter_open';
    trigger.innerHTML='<span>Filtres Airsoft</span><span class="aw-collection-filter-trigger__count" data-aw-filter-trigger-count></span>';
    const sortForm=toolbar.querySelector('form');
    if(sortForm)toolbar.insertBefore(trigger,sortForm);else toolbar.append(trigger);
  }else{
    const label=trigger.querySelector('span:first-child');
    if(label)label.textContent='Filtres Airsoft';
  }

  trigger._awP1FilterController?.abort?.();
  const controller=new AbortController();
  trigger._awP1FilterController=controller;
  const signal=controller.signal;
  document.documentElement.classList.remove('aw-filter-open');
  trigger.setAttribute('aria-expanded','false');

  const countNode=trigger.querySelector('[data-aw-filter-trigger-count]');
  const initialActiveCount=Number(drawer.dataset.activeCount||0);
  const syncPendingState=()=>{
    const count=checkedInputs().length;
    if(countNode)countNode.textContent=count>0?String(count):'';
    if(clearButton)clearButton.disabled=(count===0&&initialActiveCount===0);
  };
  syncPendingState();

  let restoreFocus=null;
  const open=()=>{
    restoreFocus=document.activeElement;
    drawer.hidden=false;
    document.documentElement.classList.add('aw-filter-open');
    trigger.setAttribute('aria-expanded','true');
    const first=panel.querySelector('[data-aw-filter-close]')||focusableNodes()[0]||panel;
    requestAnimationFrame(()=>first?.focus?.());
    track('collection_technical_filters_opened',{version:VERSION,groups:groupCount,active:checkedInputs().length,path:location.pathname});
  };
  const close=()=>{
    drawer.hidden=true;
    document.documentElement.classList.remove('aw-filter-open');
    trigger.setAttribute('aria-expanded','false');
    if(restoreFocus&&typeof restoreFocus.focus==='function')restoreFocus.focus();
  };
  const buildFilteredUrl=()=>{
    const url=new URL(location.href);
    const allowed=allowedParams();
    allowed.forEach(param=>url.searchParams.delete(param));
    url.searchParams.delete('page');
    checkedInputs().forEach(input=>{
      if(allowed.includes(input.name))url.searchParams.append(input.name,input.value);
    });
    return url;
  };
  const applyFilters=()=>{
    const selected=checkedInputs();
    const url=buildFilteredUrl();
    track('collection_technical_filters_applied',{version:VERSION,active:selected.length,groups:allowedParams().length,path:location.pathname});
    close();
    location.assign(url.href);
  };

  trigger.addEventListener('click',open,{signal});
  closeButtons.forEach(button=>button.addEventListener('click',close,{signal}));
  document.addEventListener('keydown',event=>{
    if(drawer.hidden)return;
    if(event.key==='Escape'){event.preventDefault();close();return;}
    if(event.key!=='Tab')return;
    const nodes=focusableNodes();
    if(!nodes.length){event.preventDefault();panel.focus();return;}
    const first=nodes[0],last=nodes[nodes.length-1],active=document.activeElement;
    if(event.shiftKey&&(active===first||!panel.contains(active))){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&(active===last||!panel.contains(active))){event.preventDefault();first.focus();}
  },{signal});

  form.addEventListener('change',event=>{
    if(event.target?.matches?.('input[type="checkbox"]'))syncPendingState();
  },{signal});
  form.addEventListener('submit',event=>{event.preventDefault();applyFilters();},{signal});
  applyButton?.addEventListener('click',event=>{event.preventDefault();applyFilters();},{signal});
  clearButton?.addEventListener('click',()=>{
    if(clearButton.disabled)return;
    const allowed=allowedParams();
    const url=new URL(location.href);
    const hasApplied=allowed.some(param=>url.searchParams.has(param))||initialActiveCount>0;
    if(!hasApplied){
      checkedInputs().forEach(input=>{input.checked=false;});
      syncPendingState();
      return;
    }
    allowed.forEach(param=>url.searchParams.delete(param));
    url.searchParams.delete('page');
    track('collection_technical_filters_cleared',{version:VERSION,path:location.pathname});
    close();
    location.assign(url.href);
  },{signal});

  drawer.dataset.awFilterReady='true';
  bindTracking();
};

const init=(scope=document)=>{
  if(sanitizeTechnicalParams())return;
  [...scope.querySelectorAll('[data-aw-filter-drawer]')].forEach(initDrawer);
};
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init(),{once:true}):init();
document.addEventListener('shopify:section:load',event=>init(event.target));
window.AWP1CollectionFilters={version:VERSION,init};
})();